export const boardActionType = {
  DRAW: 'DRAW',
};
